import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next'; 
import "./homepagecomponents.css"

const HomepageComp8 = () => {
    const { t } = useTranslation(); 
    const ref = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setIsVisible(true);
                observer.unobserve(entry.target);
            }
        });
    });

    useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [ref]);

    return (
        <div className={`homepage-component-container homepage-comp4-container  ${isVisible ? 'fade-in' : ''}`} ref={ref}>

            <div className='md:grid grid-cols-2 gap-8 md:px-8'>
                <div>
                    <div className='homepage-img8'></div>
                </div>
                <div>
                    <h1 className='homepage-title2'>
                        {t('homepage.comp8.title')}
                    </h1>
                    <p className='homepage-text3'>
                        {t('homepage.comp8.desc1')}
                    </p>
                    <p className='homepage-text3'>
                        {t('homepage.comp8.desc2')}
                    </p>
                    <ul className='homepage-text3 list-disc pl-8'>
                        <li>{t('homepage.comp8.opportunities.opp1')}</li>
                        <li>{t('homepage.comp8.opportunities.opp2')}</li>
                        <li>{t('homepage.comp8.opportunities.opp3')}</li>
                        <li>{t('homepage.comp8.opportunities.opp4')}</li>
                        <li>{t('homepage.comp8.opportunities.opp5')}</li>
                    </ul>
                    {/* <p className='homepage-text3'>Join us in redefining the future of responsible mining, where every investment plays a vital role in sustainable development.</p> */}
                </div>

            </div>

        </div>
    )
}

export default HomepageComp8;